<template>
    <div class="modal" tabindex="-1" role="dialog" id="muven-warning-muven-modification-modal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"> 
                        <span>Dados da retaguarda</span>
                    </h5>
                </div>
                <div class="modal-body">
                    <div>
                        <p>Foi selecionada a opção <b>{{allOption}}</b>, mas algumas informações foram modificadas no formulário.</p>
                        <p>Para que não haja a sobrescrita de nenhum dado aqui presente, escolha quais dados o Muven deverá receber da sua retaguarda.</p>

                        <div class="mt-2">
                            <multiselect
                                    v-model="chosenAllowImport"
                                    :options="allowImportOptions"
                                    :multiple="false"
                                    :show-labels="false"
                                    :allow-empty="false"
                                    label="description"
                                    track-by="enum"
                                    placeholder="" />
                        </div>                                             
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" 
                        class="btn btn-outline-primary" 
                        :disabled="!isChosenOptionValid"
                        @click="confirm()">Confirmar</button>

                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="hide()">Fechar</button>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
import modalService from "@/utils/services/ModalService";
import { ProductFormModel } from '../models/ProductFormModel';
import { AllowImportEnum } from '@c2b/muven-commons';

const ID_MODAL_WARNING_MUVEN_MODIFICATION = '#muven-warning-muven-modification-modal'

export default {
    name: 'ProductFormWarningCmp',
    data() {
        return {
            allowImportOptions: [
                {enum: "", description: ""},
                ...ProductFormModel.getAllowImportOptions(),
            ],
            chosenAllowImport: {
                enum: "",
                description: "",
            },
        }
    },
    methods: {
        confirm() {
            this.$emit('confirm', this.chosenAllowImport)
            this.hide()
        },
        show() {
            modalService.show(ID_MODAL_WARNING_MUVEN_MODIFICATION)
        },
        hide() {
            modalService.hide(ID_MODAL_WARNING_MUVEN_MODIFICATION)
        },
    },
    computed: {
        allOption() {
            return ProductFormModel.getAllowImport(AllowImportEnum.All).description
        },
        isChosenOptionValid() {
            return this.chosenAllowImport.enum !== ""
        },
    },
}
</script>